(() => {
  const panel = document.getElementById('cm-favorites-panel');
  if (!panel) return;
  const key = 'chicmilano-saved-bags';
  const list = panel.querySelector('[data-cm-favorites-items]');
  const status = panel.querySelector('[data-cm-favorites-status]');
  const labels = JSON.parse(panel.querySelector('[data-cm-favorites-strings]').textContent);
  const root = panel.dataset.root.replace(/\/?$/, '/');
  const cache = new Map();
  const choices = new Map();
  let generation = 0;
  let transferBusy = false;
  let movedCount = 0;
  let saved = [];
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(handle)))] : [];
    } catch { return saved; }
  };
  saved = read();
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const sync = () => {
    document.querySelectorAll('[data-cm-save]').forEach(button => button.setAttribute('aria-pressed', String(saved.includes(button.dataset.cmSave))));
    document.querySelectorAll('[data-cm-favorites-count]').forEach(node => { if (node.textContent !== String(saved.length)) node.textContent = String(saved.length); });
  };
  const persist = () => {
    try { localStorage.setItem(key, JSON.stringify(saved)); } catch {}
    sync();
    if (panel.open) render();
  };
  const remove = handle => {
    saved = saved.filter(item => item !== handle);
    persist();
  };
  const money = amount => new Intl.NumberFormat(panel.dataset.locale || 'en', {
    style: 'currency', currency: panel.dataset.currency || 'USD', useGrouping: false,
    minimumFractionDigits: amount % 100 === 0 ? 0 : 2, maximumFractionDigits: 2
  }).format(amount / 100);
  const fetchProduct = handle => {
    if (!cache.has(handle)) cache.set(handle, fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }).then(response => {
      if (!response.ok) throw new Error('Unavailable');
      return response.json();
    }).catch(error => { cache.delete(handle); throw error; }));
    return cache.get(handle);
  };
  const makeRemove = handle => {
    const button = el('button', 'cm-favorites-remove', labels.remove);
    button.type = 'button';
    button.addEventListener('click', () => remove(handle));
    return button;
  };
  const setBusy = busy => {
    transferBusy = busy;
    panel.setAttribute('aria-busy', String(busy));
    panel.querySelectorAll('.cm-favorites-select,.cm-favorites-slide input,.cm-favorites-remove').forEach(control => {
      if (busy) { control.dataset.wasDisabled = String(control.disabled); control.disabled = true; }
      else { control.disabled = control.dataset.wasDisabled === 'true'; delete control.dataset.wasDisabled; }
    });
    panel.querySelector('[data-cm-favorites-cart]').setAttribute('aria-disabled', String(busy));
  };
  const movedMessage = () => labels.moved.replace('[count]', String(movedCount));
  const transfer = async (handle, select, range, caption) => {
    if (transferBusy) return;
    setBusy(true);
    caption.textContent = labels.adding;
    status.textContent = '';
    let added = false;
    try {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }], sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || labels.add_error);
      added = true;
      movedCount += 1;
      saved = saved.filter(item => item !== handle);
      try { localStorage.setItem(key, JSON.stringify(saved)); } catch {}
      sync();
      try {
        const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Cart refresh');
        const cart = await cartResponse.json();
        cart.sections = result.sections;
        if (sections.length && sections.every(id => typeof result.sections?.[id] === 'string')) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'cm:favorites', cart } }));
        } else document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch { document.dispatchEvent(new CustomEvent('cart:refresh')); }
    } catch (error) {
      status.textContent = error.message || labels.add_error;
    } finally {
      setBusy(false);
      if (added) {
        await render();
        status.textContent = movedMessage();
        panel.querySelector('[data-cm-favorites-cart]').focus({ preventScroll: true });
      } else {
        range.value = '0';
        range.style.setProperty('--cm-slide-progress', '0%');
        caption.textContent = labels.slide;
      }
    }
  };
  const card = (handle, product) => {
    const item = el('article', 'cm-favorites-item');
    item.dataset.favoriteHandle = handle;
    const imageLink = el('a', 'cm-favorites-item__image');
    const productUrl = root + 'products/' + encodeURIComponent(handle);
    imageLink.href = productUrl;
    const image = el('img');
    image.width = 120;
    image.height = 150;
    image.alt = product.title;
    image.loading = 'lazy';
    imageLink.append(image);
    const info = el('div', 'cm-favorites-item__info');
    const heading = el('h3');
    const title = el('a', '', product.title);
    title.href = productUrl;
    heading.append(title);
    const price = el('p', 'cm-favorites-price');
    const controls = el('div', 'cm-favorites-controls');
    const selectId = 'cm-favorite-variant-' + handle;
    const label = el('label', 'cm-favorites-options-label', labels.options);
    label.htmlFor = selectId;
    const select = el('select', 'cm-favorites-select');
    select.name = 'id';
    select.id = selectId;
    select.setAttribute('aria-label', product.title + ' — ' + labels.options);
    product.variants.forEach(variant => {
      const option = el('option', '', variant.title + (variant.available ? '' : ' — ' + labels.sold_out));
      option.value = String(variant.id);
      option.disabled = !variant.available;
      select.append(option);
    });
    const initial = product.variants.find(variant => variant.available && String(variant.id) === choices.get(handle)) || product.variants.find(variant => variant.available) || product.variants[0];
    select.value = String(initial.id);
    const slide = el('div', 'cm-favorites-slide');
    const caption = el('span', 'cm-favorites-slide__caption', labels.slide);
    caption.setAttribute('aria-hidden', 'true');
    const range = el('input');
    range.type = 'range';
    range.min = '0';
    range.max = '100';
    range.step = '1';
    range.value = '0';
    range.dir = 'ltr';
    range.setAttribute('aria-label', labels.slide + ' — ' + product.title);
    range.setAttribute('aria-valuetext', labels.slide);
    range.addEventListener('input', () => { range.style.setProperty('--cm-slide-progress', range.value + '%'); });
    range.addEventListener('change', () => {
      if (Number(range.value) >= 95) transfer(handle, select, range, caption);
      else { range.value = '0'; range.style.setProperty('--cm-slide-progress', '0%'); }
    });
    slide.append(caption, range);
    const update = () => {
      const variant = product.variants.find(value => String(value.id) === select.value) || initial;
      choices.set(handle, String(variant.id));
      price.replaceChildren();
      if (variant.compare_at_price > variant.price) price.append(el('s', '', money(variant.compare_at_price)));
      price.append(el('strong', '', money(variant.price)));
      range.disabled = !variant.available;
      caption.textContent = variant.available ? labels.slide : labels.sold_out;
      title.href = imageLink.href = productUrl + '?variant=' + variant.id;
      const source = variant.featured_image?.src || product.featured_image;
      if (source) {
        const url = new URL(source, location.origin);
        url.searchParams.set('width', '280');
        image.src = url.href;
      }
    };
    select.addEventListener('change', update);
    update();
    if (product.variants.length === 1 && initial.title === 'Default Title') { label.hidden = true; select.hidden = true; }
    controls.append(label, select, slide);
    info.append(heading, price, controls, makeRemove(handle));
    item.append(imageLink, info);
    return item;
  };
  const render = async () => {
    const current = ++generation;
    status.textContent = movedCount ? movedMessage() : '';
    list.replaceChildren();
    if (!saved.length) { list.append(el('p', 'cm-favorites-empty', labels.empty)); return; }
    const entries = saved.map(handle => {
      const placeholder = el('div', 'cm-favorites-loading', labels.item_loading);
      list.append(placeholder);
      return { handle, placeholder };
    });
    await Promise.allSettled(entries.map(async ({ handle, placeholder }) => {
      try {
        const product = await fetchProduct(handle);
        if (current !== generation || !saved.includes(handle)) return;
        placeholder.replaceWith(card(handle, product));
      } catch {
        if (current !== generation) return;
        const failed = el('div', 'cm-favorites-failed');
        const retry = el('button', 'cm-favorites-remove', labels.retry);
        retry.type = 'button';
        retry.addEventListener('click', render);
        failed.append(el('p', '', labels.load_error), retry, makeRemove(handle));
        placeholder.replaceWith(failed);
      }
    }));
  };
  const open = () => {
    if (panel.open) return;
    panel.showModal();
    document.documentElement.classList.add('cm-favorites-open');
    saved = read();
    sync();
    render();
  };
  panel.addEventListener('close', () => {
    document.documentElement.classList.remove('cm-favorites-open');
  });
  panel.querySelector('[data-cm-favorites-close]').addEventListener('click', () => panel.close());
  panel.querySelector('[data-cm-favorites-cart]').addEventListener('click', event => {
    event.preventDefault();
    if (transferBusy) return;
    panel.close();
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();
    else location.assign(root + 'cart');
  });
  panel.addEventListener('click', event => { if (event.target === panel) { const bounds = panel.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) panel.close(); } });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-cm-favorites-open]')) { open(); return; }
    const button = event.target.closest('[data-cm-save]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.cmSave;
    if (!handle || !/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return;
    saved = saved.includes(handle) ? saved.filter(value => value !== handle) : [...saved, handle];
    persist();
  });
  window.addEventListener('storage', event => { if (event.key === key) { saved = read(); sync(); if (panel.open) render(); } });
  document.addEventListener('shopify:section:load', sync);
  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  sync();
})();
